export const supportedFiatCurrencies = ['ZAR', 'GBP', 'USD', 'EUR'];
